window.Lang = require('lang.js');
export const lang = new Lang({
    messages: require('./messages.json'),
    locale: document.documentElement.lang,
    fallback: 'en',
});
